import { useEffect, useState } from "react"

export const breakPoint = 640

export enum DeviceType {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

const getDeviceType = (width: number): DeviceType => {
  if (width < breakPoint) return DeviceType.MOBILE
  return DeviceType.DESKTOP
}

export default function useWindowDimensions() {
  const hasWindow = typeof window !== "undefined"

  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : "100vw"
    const height = hasWindow ? window.innerHeight : "100vh"
    const deviceType = hasWindow ? getDeviceType(window.innerWidth) : DeviceType.DESKTOP

    return {
      width,
      height,
      deviceType,
    }
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    if (!hasWindow) return

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWindow])

  return windowDimensions
}
